<template>
  <b-card class="shadow" style="min-height: 700px" ref="printMe">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Gráficos de Acompanhamentos - PAF") }}
          </h5>
          <!-- <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
          </b-button-group> -->
          <template v-if="tabAtiva === 'Por Período'">
              <div class="row">
                <form-select
                  grid="6"
                  label="Ano"
                  :itens="years"
                  v-model="filtroYear"
                  @change="getAnalytics()"
                  :style="{ width: '350px', height: '40px' }"
                />

                <form-select
                  grid="6"
                  label="Mês"
                  :itens="months"
                  v-model="filtroMonth"
                  placeholder="Selecione um mês"
                  @change="getAnalytics()"
                  :style="{ width: '350px', height: '40px' }"
                />
              </div>
          </template>
        </div>
        
        <div class="col-md-12 px-0" v-if="tabAtiva === 'Por Período'">
          <div class="col-12">
            <p>
              Período de pesquisa selecionado:
              <b>{{ report.datas.start }} - {{ report.datas.end }}</b>
                <b-link
                  href="#"
                  @click.prevent="void 0"
                  class="mb-2"
                  variant="info"
                  v-b-popover.hover.top="
                    'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                  "
                >
                  <i class="fas fa-info-circle"></i>
                </b-link>
            </p>
          </div>
          
        </div>
        
      </div>

      <!-- <filter-reports
        :report="report"
        @loadlist="getAnalytics"
        :showFilterReport="viewFilterReport"
        @hideFilter="viewFilters"
        @update-datas="atualizarDatas"
      ></filter-reports> -->

      <div class="col-12" id="boxPrint">
        <b-tabs content-class="mt-3">
          <b-tab
            title="Por Período"
            active
            @click.prevent="changeTab('Por Período')"
          >
            <div class="col-md-12" v-if="tabAtiva == 'Por Período'">
              <area-graph
                :loading="loading"
                :data="report.por_periodo"
                titulo="Por Período"
                :range="range"
                sizearea="300px"
                sizecard="375px"
                tipo="acompanhamentos"
              />
            </div>
            <div class="col-md-12">
              <p class="text-muted small pb-1 mb-1">
                Total de
                <b v-if="report.total_por_periodo"
                  >({{ report.total_por_periodo }})
                </b>
                {{ tabAtiva }}
              </p>
            </div>
          </b-tab>
          <b-tab title="Por Tipo" @click.prevent="changeTab('Por Tipo')">
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Tipo'">
                <h4>Vulnerabilidades</h4>
                <bar-chart :data="report.por_tipos"></bar-chart>
                <h4>Violação de Direitos</h4>
                <pie-chart
                  :donut="true"
                  :data="report.por_tipos_violencias"
                  height="600px"
                ></pie-chart>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="Por Unidades"
            @click.prevent="changeTab('Por Unidades')"
          >
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Unidades'">
                <pie-chart
                  :donut="true"
                  :data="report.por_unidades"
                  height="600px"
                ></pie-chart>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="box-btn-print no-print">
        <b-button
          v-if="!loading"
          :title="$t('Imprimir')"
          class="py-2"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
          @click="printHtml()"
        >
          <i class="fas fa-print"></i>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "AcompanhamentosGraficos",
  components: {
        GChart,
    },
  data() {
    return {
      loading: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      loadingSearchTipos: true,
      range: "yearly",
      report: {
        por_periodo: [],
        total_por_periodo: 0,
        datas: {
          start: "",
          end: "",
        },
      },
      filtros: {},
      tabAtiva: "Por Período",
      years: [],
      months: [],
      filtroYear: moment().format("YYYY"),
      filtroMonth: null,
    };
  },
  mounted() {
    this.getAnalytics();
  },

  methods: {
    changeTab(value) {
      if (value) {
        this.tabAtiva = value;
      } else {
        this.tabAtiva = "Por Período";
      }
      this.getAnalytics();
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    atualizarDatas(dados) {
      this.report.datas.start = dados.start;
      this.report.datas.end = dados.end;
    },
    getAnalytics() {
      if (this.report.datas.start) {
        this.filtros.data_inicial = this.report.datas.start;
      }
      if (this.report.datas.end) {
        this.filtros.data_final = 
          this.report.datas.end
        ;
      }

      if (this.filtroMonth) {
        this.range = "monthly";
      } else {
        this.range = "yearly";
      }

      this.loading = true;
      const tab = { tab: this.tabAtiva };
      axios
        .get("api/dashboard/report/acompanhamentos/graficos", {
          params: {
            filtros: this.filtros,
            range: this.range,
            ...tab,
            filtroYear: this.filtroYear,
            filtroMonth: this.filtroMonth,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data.data;
          this.years = response.data.data.years;
          this.months = response.data.data.months;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

